import React from 'react';
import { EcosystemTemplate, EcosystemTemplateData } from '../../templates/EcosystemTemplate';

// Reliable placeholders
const PLACEHOLDERS = {
    logo: 'https://picsum.photos/seed/protocol-logo/100/100',
    partner1: 'https://picsum.photos/seed/partner1/100/100',
    partner2: 'https://picsum.photos/seed/partner2/100/100',
    partner3: 'https://picsum.photos/seed/partner3/100/100',
    partner4: 'https://picsum.photos/seed/partner4/100/100',
    partner5: 'https://picsum.photos/seed/partner5/100/100',
    partner6: 'https://picsum.photos/seed/partner6/100/100',
    team1: 'https://picsum.photos/seed/team1/200/200',
    team2: 'https://picsum.photos/seed/team2/200/200',
    team3: 'https://picsum.photos/seed/team3/200/200',
    team4: 'https://picsum.photos/seed/team4/200/200',
};

// Sample data for a DeFi protocol
const sampleEcosystemData: EcosystemTemplateData = {
    identity: {
        name: 'NexusProtocol',
        logo: PLACEHOLDERS.logo,
        tagline: 'The liquidity layer for cross-chain DeFi',
    },

    hero: {
        badge: '🚀 V2 Mainnet Now Live',
        headline: 'The Future of Cross-Chain Liquidity',
        gradientWord: 'Cross-Chain',
        subline: 'Seamlessly move assets across 12+ chains with the lowest fees and fastest execution. Powered by our novel intent-based architecture.',
        primaryCta: { text: 'Launch App', link: '#' },
        secondaryCta: { text: 'Read Docs', link: '#' },
    },

    tokenStats: [
        { value: '$2.4B', label: 'Total Volume' },
        { value: '847K', label: 'Unique Users' },
        { value: '12', label: 'Chains Supported' },
        { value: '$48M', label: 'TVL' },
    ],

    partners: [
        { name: 'a16z crypto', logo: PLACEHOLDERS.partner1, type: 'Lead Investor', link: '#' },
        { name: 'Paradigm', logo: PLACEHOLDERS.partner2, type: 'Investor', link: '#' },
        { name: 'Coinbase Ventures', logo: PLACEHOLDERS.partner3, type: 'Investor', link: '#' },
        { name: 'Chainlink', logo: PLACEHOLDERS.partner4, type: 'Integration', link: '#' },
        { name: 'LayerZero', logo: PLACEHOLDERS.partner5, type: 'Integration', link: '#' },
        { name: 'Arbitrum', logo: PLACEHOLDERS.partner6, type: 'Ecosystem', link: '#' },
    ],

    roadmap: [
        {
            quarter: 'Q1 2025',
            title: 'V1 Mainnet Launch',
            description: 'Initial release supporting Ethereum, Arbitrum, and Optimism with basic swap functionality.',
            status: 'completed',
        },
        {
            quarter: 'Q2 2025',
            title: 'Multi-Chain Expansion',
            description: 'Added support for Polygon, Base, and BSC. Introduced limit orders and partial fills.',
            status: 'completed',
        },
        {
            quarter: 'Q3 2025',
            title: 'V2 Architecture',
            description: 'Complete protocol redesign with intent-based execution, reducing fees by 60%.',
            status: 'active',
        },
        {
            quarter: 'Q4 2025',
            title: 'Governance & Token',
            description: 'Launch of NXS token with staking, governance, and fee sharing for liquidity providers.',
            status: 'upcoming',
        },
        {
            quarter: 'Q1 2026',
            title: 'Cross-Chain Lending',
            description: 'Introducing cross-chain collateralized lending with unified position management.',
            status: 'upcoming',
        },
    ],

    team: [
        {
            name: 'Sarah Chen',
            role: 'Co-Founder & CEO',
            avatar: PLACEHOLDERS.team1,
            twitter: 'https://twitter.com/sarahchen',
        },
        {
            name: 'Marcus Rodriguez',
            role: 'Co-Founder & CTO',
            avatar: PLACEHOLDERS.team2,
            twitter: 'https://twitter.com/marcusdefi',
        },
        {
            name: 'Emma Liu',
            role: 'Head of Research',
            avatar: PLACEHOLDERS.team3,
            twitter: 'https://twitter.com/emmacrypto',
        },
        {
            name: 'James Park',
            role: 'Lead Engineer',
            avatar: PLACEHOLDERS.team4,
            twitter: 'https://twitter.com/jpark_dev',
        },
    ],

    cta: {
        title: 'Ready to experience seamless cross-chain?',
        description: 'Start swapping across 12+ chains with the lowest fees in DeFi.',
        buttons: [
            { text: 'Launch App', link: '#', primary: true },
            { text: 'Join Community', link: '#', primary: false },
        ],
    },

    social: {
        twitter: 'https://twitter.com/nexusprotocol',
        discord: 'https://discord.gg/nexus',
        github: 'https://github.com/nexus-protocol',
        telegram: 'https://t.me/nexusprotocol',
    },

    links: [
        { text: 'Documentation', href: '#' },
        { text: 'Bug Bounty', href: '#' },
        { text: 'Brand Assets', href: '#' },
    ],
};

const EcosystemDemo: React.FC = () => {
    return <EcosystemTemplate data={sampleEcosystemData} />;
};

export default EcosystemDemo;
